module.exports = __webpack_public_path__ + "img/Technology_img.1b1c6ac0.png";